export const FEATURE_FLAGS = {
  enableCreditTable: true
} as const;
